export enum EmailValidationState {
  New = 1,
  Validated = 2,
  NotValidated = 3,
}
